import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { IEvent, ISport } from 'bets.oddprovider.lib.common.ts/models'
import { ApiResponseGetListData } from 'fwork-jsts-common/src/api'
import { IApiClientResult } from 'fwork-jsts-common/src/apiClient'
import { IDefaultAction, IDefaultState } from 'fwork.react.apptemplate'
import { FilterQuery } from 'mongoose'
import axios from '../../apiClient/axios'
import { EventsApiClient } from '../../apiClient/events'
import { SportsApiClient } from '../../apiClient/sports'

export interface IEventsAction extends IDefaultAction {
  payload?: IEvent[],
  sports?: ISport[],
}

export interface IEventsState extends IDefaultState {
  payload?: IEvent[],
  sports?: ISport[],
  filter?: FilterQuery<IEvent>
}

const initState: IEventsState = {}

const getSportsIdsFromEvents = (events: IEvent[]): number[] => [...new Set(events.map(e => e.sport_id))]

const getSportsFromData = async (events: IEvent[]): Promise<(ISport)[] | undefined> => {
  const where: FilterQuery<ISport> = { id: { $in: getSportsIdsFromEvents(events) } }

  const apiResult: IApiClientResult<ApiResponseGetListData<ISport>> = await new SportsApiClient(axios).get({
    where
  })
  // call api
  return apiResult.data?.payload
}

export const eventsStateLoadFromApi = createAsyncThunk(
  'eventsStateLoadFromApi',
  async (arg: {
    where?: FilterQuery<IEvent>,
    onSuccess?: () => void,
    onError?: (msg?: string) => void,
    onFinally?: () => void
  }) => {

    const apiResult: IApiClientResult<ApiResponseGetListData<IEvent>> = await new EventsApiClient(axios).get({
      where: arg.where,
      sort: { sport_id: 1, start_date: 1, "participants.name": 1 }
    })
    const eventsApiGetResult: ApiResponseGetListData<IEvent> | undefined = apiResult.data

    let sports: ISport[] | undefined
    if (apiResult.data?.payload?.length)
      sports = await getSportsFromData(apiResult.data.payload)

    if (apiResult.success) {
      if (arg.onSuccess)
        arg.onSuccess()
    }
    else if (arg.onError)
      arg.onError(apiResult.msg)

    if (arg.onFinally)
      arg.onFinally()

    return {
      eventsApiGetResult: eventsApiGetResult,
      sports,
      where: arg.where
    }
  }
)

export const eventsSlice = createSlice({
  name: 'eventsSlice',
  initialState: initState,
  reducers: {
    clear: (state) => {
      state.payload = []
      state.sports = []
    }
  },
  extraReducers: (builder) => {
    builder.addCase(eventsStateLoadFromApi.pending, (state) => {
      if (!state.options)
        state.options = {}
      state.options.loading = true
    })
    builder.addCase(eventsStateLoadFromApi.fulfilled, (state, response) => {
      if (state.options)
        state.options.loading = false
      state.payload = response.payload.eventsApiGetResult?.payload
      state.sports = response.payload.sports
      state.filter = response.payload.where
    })
    builder.addCase(eventsStateLoadFromApi.rejected, (state) => {
      if (state.options)
        state.options.loading = false
    })
  }
})

export const { clear: clearEvents } = eventsSlice.actions
export default eventsSlice.reducer